export const getAssetsUrl = (path = '') =>
  '' +
  (process.env.NODE_ENV === 'development' ? '/assets/' : './assets/') +
  path;
